import { createSelector } from 'reselect';
import resolveRequest, { getRequestStatus } from '@clearscore-group/lib.helpers.resolve-request';

const resolveFetchStatus = (state) => resolveRequest(state, 'market.fetchStatus');

export default createSelector(resolveFetchStatus, (fetchStatus) => getRequestStatus(fetchStatus));
